module.exports = __webpack_public_path__ + "img/spotCheckBg.24a2d9e4.png";